import React from 'react';

import StonesStore from "./../../stores/stonesStore";
import * as Misc from './../../misc';

export default () => {
  const f = StonesStore.fabricator();
  if (!f) return null;
  function quoteDecode(text){
    return text.replace('&squot;', '\'');
  }
  return (
    <div className="review-submit-fabricator-lable">
      <span className="review-submit-fabricator-lable-title">fabricator information</span>
      <h11>{quoteDecode(f.Name)}</h11>
      <h12>{f.Address1}<br/>{f.City}, {f.Provence} {f.Postal}<br/>P: {Misc.formatPhone(f.Phone) }</h12>
    </div>
  );
}




// WEBPACK FOOTER //
// ./src/components/projectSummary/fabricatorInfo.js